PJQ.views.dailyReports.InspectionLogManagement = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'inspection-log-management')
    },
    events: {
        'click .btn-add-log': 'addClicked',
        'click .btn-edit-log': 'editClicked',
        'click .btn-delete-log': 'deleteClicked'
    },
    beforeFirstRender: function () {
        this.options.isAdmin = PJQ.app.session.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
            && this.options.project.hasPermission('dailyReports.isAdminInspectionLogs');

        this.listenTo(this.collection, 'sync', _.bind(function () {
            this.dataTable.refresh();
        }, this));
    },
    beforeRender: function () {
        this.options.isLocked = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DAILY_REPORT_IS_LOCKED_AFTER_SUBMIT) && this.options.dailyReport.get('status') === 1;
        this.options.canEdit = this.options.project.hasPermission('dailyReports.canAddInspectionLogs') && !this.options.isLocked;
    },
    renderData: function () {
        return {
            project: this.options.project,
            canEdit: this.options.canEdit
        };
    },
    afterRender: function () {
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: '.inspection-logs-data-table-container',
            data: this.collection.models,
            isHideSearch: true,
            rowId: "cid",
            order: [1, 'asc'],
            language: {
                zeroRecords: this.options.canEdit ? 'Click "Add Log" to create a new inspection log' : 'No inspection logs were added for this day'
            },
            onRowDoubleClick: _.bind(function (row) {
                this.editLog(row.data());
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit',
                        onClick: _.bind(function (row) {
                            this.editLog(row.data());
                        }, this),
                        isShown: _.bind(function () {
                            return this.options.canEdit;
                        }, this)
                    },
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.editLog(row.data());
                        }, this),
                        isShown: _.bind(function () {
                            return !this.options.canEdit;
                        }, this)
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        isShown: _.bind(function () {
                            return this.options.isAdmin && this.options.canEdit;
                        }, this),
                        onClick: _.bind(function (row) {
                            this.deleteLog(row);
                        }, this)
                    }
                ]
            },
            columns: [
                {
                    "data": "attachments",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "40px",
                    "render": function (data) {
                        let attachmentCount = _.size(data.models);
                        return '<div><span class="fal fa-paperclip mr-1 ' + (attachmentCount > 0 ? 'text-success' : 'text-muted') + '"></span><span class="' + (attachmentCount > 0 ? 'text-dark' : 'text-muted') + '">' + attachmentCount.toString() + '</span></div>';
                    }
                },
                {
                    "data": "attributes.type",
                    "title": "Type",
                    "width": "10%"
                },
                {
                    "data": "",
                    "title": "Contact",
                    "searchable": false,
                    "width": "20%",
                    "render": function (data, type, row) {
                        let result = 'Not set';
                        if (row.contact != null) {
                            result = PJQ.helpers.contacts.getContactAnchor({
                                id: row.contact.id,
                                name: row.contact.get('companyName')
                            });
                        } else {
                            let name = row.get('name');
                            if (_.size(name) > 0) {
                                result = name;
                            }
                        }
                        return result;
                    }
                },
                {
                    "data": "attributes.time",
                    "title": "Time",
                    "searchable": false,
                    "width": "80px",
                    "render": function (data) {
                        if (data != null) {
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.TIME);
                        }
                        return 'Not Set';
                    }
                },
                {
                    "data": "attributes.status",
                    "title": "Status",
                    "width": "100px",
                    "render": function (data) {
                        let statusName = PJQ.constants.dailyReports.inspectionLogs.statusNames[data];
                        return statusName ? statusName : '';
                    }
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "80px",
                    "render": _.bind(function () {
                        let buttons;
                        if (this.options.canEdit) {
                            buttons = '<button type="button" class="btn btn-info btn-edit-log ht-30p wd-35p mr-1 fs-14"><span class="fal fa-pencil"></span></button>';
                        } else {
                            buttons = '<button type="button" class="btn btn-info btn-edit-log ht-30p wd-35p mr-1 fs-14"><span class="fal fa-search"></span></button>';
                        }
                        if (this.options.isAdmin && this.options.canEdit) {
                            buttons += '<button type="button" class="btn btn-danger btn-delete-log ht-30p wd-35p fs-14"><span class="fal fa-trash"></span></button>';
                        }
                        return '<div class="text-align-right show-on-row-hover">' + buttons + '</div>';
                    }, this)
                }
            ]
        });
    },
    addClicked: function () {
        let newLog = new PJQ.models.dailyReports.InspectionLog({
            dailyReportId: this.options.dailyReport.id,
            time: new Date()
        });
        this.editLog(newLog);
    },
    editClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr'));
        this.editLog(row.data());
    },
    editLog: function (log) {
        new PJQ.views.dailyReports.EditInspectionLogModal({
            model: log,
            project: this.options.project,
            isLocked: this.options.isLocked,
            onSave: _.bind(function (log) {
                if (log.hasChanged() || log.isNew()) {
                    if (log.isNew()) {
                        this.collection.add(log);
                        this.dataTable.addRow(log);
                    }
                    log.save(null, {
                        notify: true
                    });
                    this.dataTable.refresh();
                }
            }, this),
            onClose: _.bind(function (log) {
                if (log.hasChanged()) {
                    log.fetch({
                        success: _.bind(function () {
                            this.dataTable.refresh();
                        }, this)
                    });
                }
            }, this),
            onDelete: _.bind(function (log) {
                if (log.id > 0) {
                    let row = this.dataTable.getRow(log.cid);
                    this.collection.remove(log);
                    log.destroy();
                    if (row != null) {
                        this.dataTable.removeRow(row);
                    }
                }
            }, this)
        });
    },
    deleteClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr'));
        this.deleteLog(row);
    },
    deleteLog: function (row) {
        let log = row.data();
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this inspection log?",
            onDelete: _.bind(function () {
                this.collection.remove(log);
                log.destroy();
                this.dataTable.removeRow(row);
            }, this)
        });
    }
});

PJQ.views.dailyReports.EditInspectionLogModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'modal-edit-inspection-log'),
        maxWidth: 800
    },
    events: {
        'click .btn-reject': 'reject',
        'click .btn-approve': 'approve',
        'click .btn-save': 'onSave',
        'click .btn-close': 'close',
        'click .btn-delete': 'onDelete'
    },
    beforeModalCreated: function () {
        this.options.isAdmin = this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
            && this.options.project.hasPermission('dailyReports.isAdminInspectionLogs');
        this.options.canEdit = this.model.isNew() || (this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
            && this.options.project.hasPermission('dailyReports.canAddInspectionLogs') && !this.options.isLocked);
    },
    renderData: function () {
        return {
            model: this.model,
            isAdmin: this.options.isAdmin,
            canEdit: this.options.canEdit
        };
    },
    afterRender: function () {
        if (this.options.canEdit) {
            new PJQ.Binder(this.$el, this.model, {
                setDefaultValues: true,
                watchElements: [
                    'input',
                    'textarea'
                ]
            });

            this.renderStatus();

            new PJQ.views.contacts.ContactsSelectInput({
                el: this.$('.log-contact'),
                context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
                selectedContact: this.model.contact,
                isSingleChoice: true,
                isReadOnly: !this.options.canEdit,
                addButton: this.$('.btn-edit-contact'),
                onChange: _.bind(function (selectedContact) {
                    this.model.contact = selectedContact;
                    this.model.set('name', '');
                    this.model.isDirty = true;
                    this.renderContact();
                }, this)
            });
        }
        this.renderContact();

        new PJQ.inputs.Datepicker({
            el: this.$('.log-time'),
            isTimeOnly: true,
            datepickerOptions: {
                defaultDate: this.model.get('time')
            },
            onChange: _.bind(function (newTime) {
                let curTime = this.model.get('time');
                if (curTime == null || PJQ.helpers.dateHelpers.checkTimesDifferent(newTime, new Date(curTime))) {
                    this.model.set('time', newTime);
                }
            }, this)
        });

        this.fileUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.log-file-upload'),
            collection: this.model.attachments,
            canUpload: this.options.canEdit,
            // includeProjectAttachments: true,
            canDelete: this.options.isAdmin && this.options.canEdit,
            previewImageDimension: 150,
            sortDirection: 'asc',
            onDelete: _.bind(function (attachment, callback) {
                if (attachment.id > 0) {
                    attachment.set('isDeleted', true);
                } else {
                    attachment.destroy();
                }
                this.model.isDirty = true;
                callback();
            }, this)
        });
    },
    reject: function () {
        this.updateStatus(PJQ.constants.dailyReports.inspectionLogs.statuses.REJECTED);
    },
    approve: function () {
        this.updateStatus(PJQ.constants.dailyReports.inspectionLogs.statuses.APPROVED);
    },
    updateStatus: function (status) {
        this.model.set('status', status);
        this.renderStatus();
    },
    renderStatus: function () {
        let status = this.model.get('status');
        this.$('.log-status>button').each(function () {
            if ($(this).data('value') === status) {
                $(this).removeClass('inactive').addClass('font-weight-normal');
            } else {
                $(this).addClass('inactive').removeClass('font-weight-normal');
            }
        });
    },
    renderContact: function () {
        let $contactSelect = this.$('.log-contact'),
            $contactName = this.$('.log-name');
        if (this.model.contact != null) {
            $contactName.addClass('hidden');
            $contactSelect.removeClass('hidden');
        } else {
            $contactSelect.addClass('hidden');
            $contactName.removeClass('hidden');
        }
    },
    onSave: function () {
        if (this.fileUploader.isUploading()) {
            new PJQ.views.BaseModal({
                header: "Files Uploading",
                body: "You can't save while files are uploading"
            });
        } else {
            if (this.options.onSave) {
                this.options.onSave(this.model);
                this.removeModal();
            }
        }
    },
    close: function () {
        if (this.options.canEdit && this.model.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.onSave();
                }, this),
                onDontSave: _.bind(function () {
                    this.onClose(this.model);
                    this.removeModal();
                }, this)
            });
        } else {
            this.onClose(this.model);
            this.removeModal();
        }
    },
    onDelete: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this inspection log?",
            onDelete: _.bind(function () {
                if (this.options.onDelete) {
                    this.options.onDelete(this.model);
                }
                this.removeModal();
            }, this)
        });
    }
});
